export default "__VITE_ASSET__BT1pw4IP__"